import api from '@/api';
import { ICard } from '@/models/cards';
// eslint-disable-next-line import/no-extraneous-dependencies
import { type ModelCardRequest, type ModelCardResponse } from '@layup/api-sdk';
import { createLayupClient } from './layupApi';

export async function createCard(card: ModelCardRequest): Promise<ModelCardResponse> {
  const { data } = await api.post('/cards', card);
  return data as ModelCardResponse;
}

export async function getCards(): Promise<ICard[]> {
  const {
    data: { clientCards },
  } = await api.get('/cards');
  return (clientCards || []) as ICard[];
}

export async function getCard(id: string): Promise<ICard> {
  const { data } = await api.get(`/cards/${id}`);
  return data as ICard;
}

export async function deleteCard(id: string): Promise<void> {
  await api.delete(`/cards/${id}`);
}

export async function updateCard(card: ICard): Promise<ICard> {
  const { data } = await api.put(`/cards/${card._id}`, card);
  return data as ICard;
}

export async function verifyCard(checkoutId: string) {
  const client = createLayupClient(false);
  const response = await client.get(`/cards/${checkoutId}/redirect?isEmbeddedCheckout=true`);
  return response;
}
